var x={maxWidth:{xl:"1400px",md:"1100px",sm:"940px"}};export{x as default};
